import React, { useRef } from "react"; 
import { QRCodeSVG } from "qrcode.react"; 
import html2canvas from "html2canvas";

const QRCodeModal = ({ showQR, onClose, encodedPath, MiniLogo, dppCode }) => {
  const cardRef = useRef(null);

  if (!showQR) return null;

const downloadQRCode = async () => {
  if (!cardRef.current) return;

  try { 
    const scale = 3;  
    
    const htmlCanvas = await html2canvas(cardRef.current, {
      scale: scale, 
      useCORS: true, 
      backgroundColor: "transparent",  
    }); 
    const image = htmlCanvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = image;
    link.download = `DPP_QR_${dppCode || "Card"}.png`;
    link.click();
    
  } catch (error) { 
    console.error("Error downloading QR Code:", error);
  }
};

  return (
    <div className="desktop-qr-modal" style={modalOverlayStyle}>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
        
        <div 
          className="desktop-qr-card-ui" 
          ref={cardRef} 
          style={cardStyle}
        >
          <div className="desktop-qr-card-header" style={headerStyle}>
            <h4 style={{ margin: 0, fontSize: "20px", fontWeight: 800, letterSpacing: "1px", color: "#ffffff" }}>
              DIGITAL PRODUCT PASSPORT
            </h4>
            <p style={{ margin: "6px 0 0 0", fontSize: "13px", fontWeight: 500, color: "rgba(255, 255, 255, 0.9)" }}>
              Secure & Verified Product Journey
            </p>
          </div>
          
          <div className="desktop-qr-card-body" style={bodyStyle}>
             
            <div className="desktop-qr-wrapper" style={qrWrapperStyle}>  
              <QRCodeSVG 
                size={130} 
                level="H"  
                value={`${window.location.origin}/${encodedPath}`} 
                style={{ display: "block", margin: "0 auto" }} 
              />
               
              {MiniLogo && (
                <div style={logoOverlayStyle}>
                  <img 
                    src={MiniLogo} 
                    crossOrigin="anonymous" 
                    alt="Brand Logo" 
                    style={logoImageStyle} 
                  />
                </div>
              )}
            </div>

            <p style={{ fontSize: "14px", color: "#475569", margin: "0 0 20px 0", lineHeight: "1.5", fontWeight: 500, textAlign: "center" }}>
              Scan to access complete lifecycle &<br />
              authenticity details of this product.
            </p>
            <p style={{ fontSize: "11px", fontWeight: 700, color: "#94a3b8", letterSpacing: "1px", margin: 0, textAlign: "center" }}>
              POWERED BY MOBILLOR
            </p>
          </div>
        </div>

        <div style={{ display: "flex", gap: "16px", marginTop: "24px" }}>
          <button onClick={downloadQRCode} style={downloadBtnStyle}>Download</button>
          <button onClick={onClose} style={closeBtnStyle}>Close</button>
        </div>
        
      </div>
    </div>
  );
};
  
const modalOverlayStyle = {
  position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
  background: "rgba(15, 23, 42, 0.7)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999,
  padding: "16px", 
  boxSizing: "border-box"
};

const cardStyle = {
  background: "#ffffff", 
  borderRadius: "0px", // यहाँ हमने border radius को 0px कर दिया है
  width: "100%", 
  maxWidth: "340px",  
  boxShadow: "0 20px 50px rgba(0,0,0,0.15)", 
  display: "flex", 
  flexDirection: "column",
  overflow: "hidden"
};

const headerStyle = {
  background: "linear-gradient( #10b981 100%)", 
  borderBottom: "4px solid #fbbf24", 
  padding: "24px 20px", 
  textAlign: "center",
};

const bodyStyle = {
  padding: "32px 24px 24px", 
  display: "flex", 
  flexDirection: "column",
  alignItems: "center", 
  background: "#ffffff",
};

const qrWrapperStyle = {
  position: "relative",  
  display: "flex", justifyContent: "center", alignItems: "center",
  background: "#ffffff", padding: "16px", borderRadius: "12px",
  boxShadow: "0 4px 16px rgba(0,0,0,0.06)", 
  marginBottom: "24px",
  border: "1px solid #f1f5f9",
  width: "fit-content", 
  boxSizing: "border-box"
};
 
const logoOverlayStyle = {
  position: "absolute",
  width: "34px",  
  height: "34px",
  backgroundColor: "#ffffff",
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const logoImageStyle = {
  width: "75%",  
  height: "75%",
  objectFit: "contain",
};

const downloadBtnStyle = {
  background: "#10b981", color: "white", border: "none", borderRadius: "8px", padding: "12px 24px", fontWeight: 700, cursor: "pointer", fontSize: "15px"
};

const closeBtnStyle = {
  background: "#3b82f6", color: "white", border: "none", borderRadius: "8px", padding: "12px 24px", fontWeight: 700, cursor: "pointer", fontSize: "15px"
};

export default QRCodeModal;